module.exports = __webpack_public_path__ + "img/23-02.55e2b737.png";